import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const useEntityCrud = ({ listUrl, baseUrl, fields, defaults, autoOpen, onChange }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [confirmId, setConfirmId] = useState(null);

  const load = useCallback(() => api.get(listUrl).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))), [listUrl]);
  const openNew = useCallback(() => { setEditing(null); setForm({ ...defaults }); setOpen(true); }, [defaults]);
  const openEdit = useCallback((it) => {
    setEditing(it);
    setForm(Object.fromEntries(fields.map((f) => [f.name, it[f.name] ?? defaults[f.name]])));
    setOpen(true);
  }, [fields, defaults]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (autoOpen) openNew(); }, [autoOpen, openNew]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editing) await api.put(`${baseUrl}/${editing.id}`, form); else await api.post(baseUrl, form);
      toast.success(editing ? "Modifications enregistrées" : "Élément créé");
      setOpen(false);
      load();
      if (onChange) onChange();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  const remove = async (it) => {
    if (confirmId !== it.id) {
      setConfirmId(it.id);
      setTimeout(() => setConfirmId(null), 4000);
      return;
    }
    try { await api.delete(`${baseUrl}/${it.id}`); toast.success("Supprimé"); load(); if (onChange) onChange(); } catch (err) { toast.error(errMsg(err)); }
    setConfirmId(null);
  };

  const setField = (name, value) => setForm((s) => ({ ...s, [name]: value }));

  return { items, open, setOpen, editing, form, setField, saving, confirmId, load, openNew, openEdit, save, remove };
};
